import React, { useState } from 'react';
import styled from 'styled-components';
import plus from '../assets/plus.svg';
import minus from '../assets/minus.svg';
import { motion, AnimatePresence } from 'framer-motion';

function Question({ title, description }) {
  const [toggle, setToggle] = useState(false);

  const btnToggler = () => {
    setToggle(!toggle);
  };

  return (
    <QuestionStyled>
      <div className="q-content">
        <div className="toggle-title">
          <h4>{title}</h4>
          <AnimatePresence>
            <motion.div animate={{ rotate: toggle ? 180 : 0 }} onClick={btnToggler}>
              <button onClick={btnToggler}>{toggle ? <img src={minus} alt="" /> : <img src={plus} alt="" />}</button>
            </motion.div>
          </AnimatePresence>
        </div>
        <AnimatePresence>
          {toggle && (
            <motion.div
              key="text-desc"
              initial={{ y: '-50%', opacity: 0 }}
              animate={{ y: 5, opacity: 1, scale: 1 }}
              exit={{ y: '-50%', opacity: 0, transition: { duration: 0.2, ease: 'easeOut' } }}
              transition={{ duration: 0.3, ease: 'easeOut' }}
            >
              {' '}
              <p className="text-desc">{description}</p>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </QuestionStyled>
  );
}

const QuestionStyled = styled.div`
  padding: 1.4rem 1rem;

  h4 {
    color: #16194f;
  }
  .toggle-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    button {
      background: transparent;
      outline: none;
      cursor: pointer;
      border: none;
    }
  }
`;

export default Question;
